import React, { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import api from "@/lib/api";

let cache = null;
export function useCutoff() {
  const [c, setC] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/settings/cutoff").then(({ data }) => { cache = data; setC(data); }).catch(() => {});
  }, []);
  return c;
}

const fmt = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" });

export default function CutoffNotice({ compact = false }) {
  const c = useCutoff();
  if (!c?.active) return null;
  const when = fmt(c.cutoff_date);
  if (compact) {
    return (
      <p className="text-xs font-semibold text-[#B91C1C] inline-flex items-center gap-1" data-testid="cutoff-notice-compact">
        <CalendarClock className="w-3.5 h-3.5" /> {c.passed ? `${c.label} cut-off has passed` : `Order by ${when} for ${c.label}`}
      </p>
    );
  }
  return (
    <div className={`mt-4 rounded-2xl border-2 p-3.5 flex items-start gap-3 ${c.passed ? "border-[#19324A]/15 bg-[#19324A]/5" : "border-[#FF6B9D] bg-[#FF6B9D]/10"}`} data-testid="cutoff-notice">
      <CalendarClock className={`w-5 h-5 shrink-0 mt-0.5 ${c.passed ? "text-[#19324A]/60" : "text-[#FF6B9D]"}`} />
      <div className="min-w-0">
        {c.passed ? (
          <p className="font-display font-bold text-[#19324A] text-sm" data-testid="cutoff-passed">The {c.label} order cut-off ({fmt(c.cutoff_date)}) has passed — personalised orders placed now will arrive after Christmas.</p>
        ) : (
          <p className="font-display font-bold text-[#19324A] text-sm" data-testid="cutoff-headline">
            Order by <span className="text-[#FF6B9D]">{when}</span> for {c.label}
            {c.days_left === 0 ? " — last day today!" : c.days_left <= 7 ? ` — only ${c.days_left} day${c.days_left === 1 ? "" : "s"} left` : ""}
          </p>
        )}
        <p className="text-xs text-[#19324A]/65 mt-0.5">{c.note || "Personalised items are made to order here in Australia, so they need a little extra time to reach you."}</p>
      </div>
    </div>
  );
}
